import { axios2 } from '@/lib/axios';
import { useQuery } from 'react-query';

interface QueryParams {
  query_id: number;
  status: string;
}

export const getUserQueries = () => {
  return axios2.get(`/admin-api/query`);
};

export const useGetUserQueries = () => {
  return useQuery({
    queryKey: ['user-queries'],
    queryFn: () => getUserQueries(),
  });
};

export const resolveQuery = (payload: QueryParams) => {
  return axios2.post(`/admin-api/query`, payload);
};
